import React, { Component } from 'react'
import { Loading } from '../../misc'
import {
    formHandler,
    Button,
    Select,
    TextInput,
} from '../../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class MonitorSelectionForm extends Component {
    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this.props.gear.monitor_types) {
            this.props.gearActions.loadMonitorTypes()
        }
        if (! this.props.gear.monitor_makes) {
            this.props.gearActions.loadMonitorMakes()
        }
    }

    _submitMonitorData = () => {
        const data = {
            monitor_type: this.state.data.monitor_type,
            make: this.state.data.make,
            model: this.state.data.model,
            screen_size: this.state.data.screen_size,
        }

        this.props.gearActions.submitMonitor(
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    render() {
        if (! this.props.gear.monitor_types || ! this.props.gear.monitor_makes) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div>
                <Select
                    error={ errors.monitor_type }
                    name="monitor_type"
                    options={ this.props.gear.monitor_types }
                    placeholder="Select monitor type"
                    updateValue={ this._updateValue }
                    value={ this.state.data.monitor_type }
                />
                <Select
                    error={ errors.make }
                    name="make"
                    options={ this.props.gear.monitor_makes }
                    placeholder="Select make"
                    updateValue={ this._updateValue }
                    value={ this.state.data.make }
                />
                <TextInput
                    error={ errors.model }
                    name="model"
                    placeholder="Enter model"
                    updateValue={ this._updateValue }
                    value={ this.state.data.model }
                />
                <TextInput
                    error={ errors.screen_size }
                    name="screen_size"
                    placeholder="Enter the screen size of this monitor"
                    updateValue={ this._updateValue }
                    value={ this.state.data.screen_size }
                />

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitMonitorData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

MonitorSelectionForm.propTypes = {
    appState: React.PropTypes.object.isRequired,
    crew_uuid: React.PropTypes.string.isRequired,
    data: React.PropTypes.object.isRequired,
    gear: React.PropTypes.object.isRequired,
    gearActions: React.PropTypes.object.isRequired,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(MonitorSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/monitor_selection_form.js